<template>
    <section :class="$style.container">
        <div :class="$style.title">

            <el-row>
                <el-col :span="12">
                    <div :class="$style.left">
                        <span style="line-height: 1.4em;font-size: 14px">{{result.title}}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div :class="$style.right">
                        <div v-if="result.type === 'TRUE-FALSE'">
                            <img v-if="result.passed === 'PASSED'" :src="imgUrl_y_green" width="15px"/>
                            <img v-else-if="result.passed === 'DENIED'" :src="imgUrl_y_grey" width="15px"/>
                            <img v-else :src="imgUrl_y_grey" width="15px"/>
                            <span style="margin-left: 5px;margin-right: 5px">|</span>
                            <img v-if="result.passed === 'PASSED'" :src="imgUrl_n_grey" width="15px"/>
                            <img v-else-if="result.passed === 'DENIED'" :src="imgUrl_n_red" width="15px"/>
                            <img v-else :src="imgUrl_n_grey" width="15px"/>
                        </div>
                        <div v-else-if="result.type === 'STAR'">
                            <Star :size='48' :score='result.stars/2'></Star>
                        </div>
                        <div v-else-if="result.type === 'SCORE'">
                            <span :class="[result.score === '1' ? $style.span_round_s:$style.span_round_f]">1</span>
                            <span :class="[result.score === '2' ? $style.span_round_s:$style.span_round_f]">2</span>
                            <span :class="[result.score === '3' ? $style.span_round_s:$style.span_round_f]">3</span>
                            <span :class="[result.score === '4' ? $style.span_round_s:$style.span_round_f]">4</span>
                            <span :class="[result.score === '5' ? $style.span_round_s:$style.span_round_f]">5</span>
                            <span :class="[result.score === '6' ? $style.span_round_s:$style.span_round_f]">6</span>
                            <span :class="[result.score === '7' ? $style.span_round_s:$style.span_round_f]">7</span>
                            <span :class="[result.score === '8' ? $style.span_round_s:$style.span_round_f]">8</span>
                            <span :class="[result.score === '9' ? $style.span_round_s:$style.span_round_f]">9</span>
                            <span :class="[result.score === '10' ? $style.span_round_s:$style.span_round_f]">10</span>
                        </div>
                        <div v-else-if="result.type === 'OPTION'" style="display: flex;justify-content: flex-end">
                            <span style="color: #86909A;line-height: 1.4em;font-size: 14px;padding-left: 10px;padding-top: 0.1em">{{getOptionInfo(result.optionInfo)}}</span>
                                <span :class="$style.span_bg" v-show="getOptionScore(result.optionInfo)">{{getOptionScore(result.optionInfo)}}</span>

                        </div>
                        <div v-else-if="result.type === ''">
                            <img :src="imgUrl_y_grey" width="15px"/>
                            <span style="margin-left: 5px;margin-right: 5px">|</span>
                            <img :src="imgUrl_n_grey" width="15px"/>
                        </div>

                    </div>
                </el-col>
            </el-row>

        </div>
        <div :class="$style.body">

            <el-row>
                <el-col :span="12" style="padding: 10px;border-right: 1px solid lightgray">
                    <div style="min-height: 100px">
                        <span>要求:</span>
                        <section style="margin-top: 4px">
                            <span style="color: #4D4D4D;line-height: 1.4em">{{result.sub_title !== 'null' ? result.sub_title:''}}</span>
                        </section>

                    </div>
                    <div>
                        <span>
                            参考图片
                        </span>
                    </div>

                    <div v-show="result.sample.length > 0" v-for="(sampleItem, index) in result.sample">
                        <span v-show="false">{{getImgUrl(sampleItem,sampleItem.photo_id)}}</span>
                        <span><img :src="showPhoto(sampleItem.photoUrl)" width="100px" height="100px"
                                   style="margin-top: 10px;float: left;margin-left: 5px"
                                   @click="dialogVisibles(sampleItem.photoUrl)"/></span>
                    </div>
                    <div v-show="result.sample.length === 0" style="min-height: 100px">

                    </div>

                </el-col>


                <!--<hr style="width: 1px;height: 100px"/>-->

                <el-col :span="12" style="padding: 10px">
                    <div style="min-height: 100px;">
                        <span>
                            实际情况:
                        </span>

                        <section style="margin-top: 4px">
                            <span style="color: #ED3B3F;line-height: 1.4em">{{result.comments}}</span>
                            <!--<span v-else style="color: #4D4D4D;line-height: 1.4em">{{result.comments}}</span>-->
                        </section>

                    </div>
                    <div>
                        <span>
                            现场照片
                        </span>
                    </div>
                    <div v-for="(photoItem, index) in result.photo">
                        <span v-show="false">{{getImgUrl(photoItem,photoItem.file_id)}}</span>
                        <span><img :src="showPhoto(photoItem.photoUrl)" width="100px" height="100px"
                                   style="margin-top: 10px;float: left;margin-left: 5px"
                                   @click="dialogVisibles(photoItem.photoUrl)"/></span>
                    </div>

                    <img v-show="vShow(result)" :src="stampUrl" width="100px" style="position:absolute;right:10px;bottom:10px"/>
                </el-col>
            </el-row>

        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogSrc" alt="">
        </el-dialog>
    </section>
</template>
<script>
    import http from '../../../../APIService/http'
    import ImgUrl_y_green from '../../../../assets/images/hook_green.png'
    import ImgUrl_y_grey from '../../../../assets/images/hook_grey.png'
    import ImgUrl_n_grey from '../../../../assets/images/fork_grey.png'
    import ImgUrl_n_red from '../../../../assets/images/fork_red.png'
    import Pic_icon from '../../../../assets/images/pic_icon.png'


    import ImgUrl from '../../../../assets/images/daqu_o.png'
    import StampUrl from '../../../../assets/images/qualified.png'
    import DisStampUrl from '../../../../assets/images/disqualification.png'
    import Star from '../item/star.vue'

    export default {
        props: {
            result: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                dialogVisible: false,
                dialogSrc: '',
                imgUrl_y_green: ImgUrl_y_green,
                imgUrl_y_grey: ImgUrl_y_grey,
                imgUrl_n_grey: ImgUrl_n_grey,
                imgUrl_n_red: ImgUrl_n_red,
                imgUrl: '',
                stampUrl: StampUrl,
                showComments: false
            }
        },
        components: {
            Star
        },
        created() {


        },
        methods: {
            getOptionInfo(info) {
                let str = '未选择'
                if (info.length > 0) {
                    str = info[0].title
                }
                return str
            },
            getOptionScore(info) {
                let str = ''
                if (info.length > 0) {
                    str = info[0].score + '分'
                }
                return str
            },
            vShow(result) {

                switch (result.type) {
                    case 'TRUE-FALSE':
                        if (result.passed === 'PASSED') {
                            this.stampUrl = StampUrl
                            this.showComments = false
                        } else if (result.passed === 'DENIED') {
                            this.stampUrl = DisStampUrl
                            this.showComments = true
                        }
                        if (result.passed) {
                            this.showComments = true
                            return true
                        }
                        break
                    case 'STAR':
                        if (parseInt(result.stars) >= parseInt(result.conformity)) {
                            this.stampUrl = StampUrl
                            this.showComments = false
                        } else if (result.stars !== '0') {
                            this.stampUrl = DisStampUrl
                            this.showComments = true
                        }
                        if (result.stars !== '0') {
                            this.showComments = true
                            return true
                        }
                        break
                    case 'SCORE':
                        if (parseInt(result.score) >= parseInt(result.conformity)) {
                            this.stampUrl = StampUrl
                            this.showComments = false
                        } else if (result.score !== '0') {
                            this.stampUrl = DisStampUrl
                            this.showComments = true
                        }
                        if (result.score !== '0') {
                            this.showComments = true
                            return true
                        }
                        break
                    case 'OPTION':
                        if (result.optionInfo.length > 0) {
                            let optionScore = 0
                            for (let option of result.optionInfo) {
                                optionScore = optionScore + parseInt(option.score)
                            }

                            if (optionScore >= parseInt(result.conformity)) {
                                this.stampUrl = StampUrl
                                this.showComments = false
                            } else {
                                this.stampUrl = DisStampUrl
                                this.showComments = true
                            }

                            return true
                        } else {
                            this.showComments = false
                            return false
                        }
                        break
                    default:
                        this.showComments = false
                        return false
                }
            },
            async getImgUrl(photoItem, id) {
                try {
                    if (photoItem.photoUrl) {
                        return
                    }

                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '58f09f86-694c-472d-bb63-64f9be093fd2',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    // let res = await http.post('/downloadphoto/downloadphotos', data)
                    let res = await http.post('https://api.retailstore365.com:15041/downloadphotos', data)
                    let array = res.data

                    if (array.length > 0) {

                        photoItem.photoUrl = array[0].thu_url

                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            dialogVisibles(photoUrl) {

                this.dialogSrc = photoUrl
                this.dialogVisible = true
            },
            showPhoto(url){
                if(!url){
                    return Pic_icon
                }else {
                    return url
                }

            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../../assets/css/default';

    .container {
        margin-top: 10px;
        border: 1px solid #DEDEDE;
        .title {

            padding: 10px 10px;
            border-bottom: 1px solid #DEDEDE;
            .left {
                span {
                    color: #F5A623;
                    font-size: 14px;
                }
            }
            .right {
                float: right;
                vertical-align: middle;
                span {
                    color: #DADAE8;
                }
                .span_bg {
                    display: inline-block;
                    min-width: 20px;
                    height: 12px;
                    font-size: 12px;
                    color: #FFFFFF;
                    text-align: center;
                    padding: 5px;
                    margin-left: 10px;
                    background: #9B9B9B;
                    border-radius: 3px;
                    float: right
                }
                .span_round_f {
                    font-size: 12px;
                    color: #86909A;
                    border-radius: 16px;
                    padding: 1px;
                    display: -moz-inline-box;
                    display: inline-block;
                    text-align: center;
                    line-height: 16px;
                    min-width: 16px;
                    border: 1px solid #86909A;
                }
                .span_round_s {
                    font-size: 12px;
                    color: #ffffff;
                    background: #4A90E2;
                    border-radius: 16px;
                    padding: 1px;
                    display: -moz-inline-box;
                    display: inline-block;
                    text-align: center;
                    line-height: 16px;
                    min-width: 16px;
                    border: 1px solid #4A90E2;
                }
            }
        }
        .body {

            span {
                font-size: 14px;
                color: #ADB3B8
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/cruiseShop/checkItems/item/item.vue